const removeHtmlTags = (html: string) => {
  if (!html) return html;
  let newHtml = html.replace(/<[^>]*>?/gm, "");
  newHtml = newHtml.replace(/(\.)(\w)/gm, "$1 $2");
  newHtml = newHtml.replace(/(&nbsp;)/gm, " ");
  newHtml = newHtml.replace(/(&#x27;)/gm, "'");
  return newHtml;
};

export default removeHtmlTags;
